import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import DetailField from '../../../../common/outlet/outlet-detail-field';
import ArrowButton from '../../../../common/button-arrow';
import ReverseScanDialog from '../reverse-scan-dialog';
import { reverseScan } from '../../../../../actions/scans';
import SellItObjectiveList from './sell-it-objective-list';
import DuplicateScanList from './duplicate-scan-list';

class ScanViewDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false,
    };
  }

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  }

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  }

  handleConfirmDialog = (result) => {
    if (result) {
      const { scannerCode: { id }, dispatch } = this.props;

      dispatch(reverseScan(id));
      this.handleCloseDialog();
    } else {
      this.handleCloseDialog();
    }
  };

  render() {
    const { scannerCode: { id, attributes } } = this.props;
    const { isDialogOpen } = this.state;
    const sellItObjectives = attributes['sell-it-objectives'];
    const duplicateScans = attributes['duplicate-scans'];
    const userEditPath = attributes['is-owner-or-staff'] ? 'details' : 'edit';

    return (
      <div className="container-fluid">
        <Col md={6}>
          <DetailField data={id} label={'ID'} />
          <DetailField data={attributes['created-at']} label={'Scan date'} />
          <DetailField data={attributes['customer-number']} label={'Customer number'} />
          <DetailField data={attributes.rep} label={'Rep'} />
          <Row>
            <Col md={6}>
              Scanning User ID:
            </Col>
            <Col md={6}>
              <Link to={`/admin/users/${attributes['user-id']}/${userEditPath}`}>
                {attributes['user-id']}
              </Link>
            </Col>
          </Row>
          <DetailField data={attributes.email} label={'Scanning User email'} />
          <DetailField data={attributes.mobile} label={'Scanning User mobile'} />
          <br />
          <Row>
            <Col md={6}>
              Product code (EAN):
            </Col>
            <Col md={6}>
              <Link to={`/admin/products/${attributes['product-id']}`}>
                {attributes['product-code']}
              </Link>
            </Col>
          </Row>
          <DetailField data={attributes['product-name']} label={'Product name'} />
          <DetailField data={attributes['outer-code']} label={'Outer code'} />
          <br />
          <DetailField data={`${attributes['valid-scan']}`} label={'Valid'} />
          <DetailField data={attributes['fail-reason']} label={'Fail Reason'} />
          <DetailField data={attributes['override-request-status'] || 'NONE'} label={'Override status'} />
          <Row>
            <Col md={6}>
              Override image:
            </Col>
            <Col md={6}>
              {attributes['override-image-url'] && (
                <Link target="_blank" to={attributes['override-image-url']}>
                  {attributes['override-image-name']}
                </Link>
              )}
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Row>
            <div className="pull-right">
              <ArrowButton
                arrow={false}
                className="pull-right"
                onClick={() => this.handleOpenDialog()}
                submit={false}
                disabled={!attributes['valid-scan']}
              >
                Reverse scan
              </ArrowButton>
            </div>
          </Row>
        </Col>
        {sellItObjectives && sellItObjectives.length > 0 && (
          <Col md={12}>
            <Row>
              <h3 className="text-uppercase">
                Linked Sell It Objectives
              </h3>
            </Row>
            <Row>
              <SellItObjectiveList sellItObjectives={sellItObjectives} />
            </Row>
          </Col>
        )}
        {duplicateScans && duplicateScans.length > 0 && (
          <Col md={12}>
            <Row>
              <h3 className="text-uppercase">
                Duplicate scans
              </h3>
            </Row>
            <Row>
              <DuplicateScanList duplicateScans={duplicateScans} />
            </Row>
          </Col>
        )}
        {isDialogOpen && <ReverseScanDialog id={id} handleConfirmDialog={this.handleConfirmDialog} />}
      </div>
    );
  }
}

export default connect(null)(ScanViewDetails);



// WEBPACK FOOTER //
// ./src/components/admin/scans/scans/view/scan-view-details.jsx